import MicroModal from "micromodal";
import ScrollLocker from "@/components/ScrollLocker";

export default class ModalController {
    constructor() {
        this.hiddenPagePopup = document.querySelector(".js-hidden-popup");
        this.modalClose = document.querySelectorAll(".js-page-popup-close");
        this.modalContainer = document.querySelectorAll(
            ".js-page-popup-container",
        );
        this.modal = document.querySelector(".js-modal");
        this.archiveLink = document.querySelector(".js-archive-url");
    }

    init() {
        let popupTrigger = document.querySelectorAll(".js-modal-trigger");

        if (popupTrigger.length < 1) {
            return;
        }

        if (this.hiddenPagePopup !== null) {
            this.hiddenPagePopup.addEventListener("click", (event) => {
                event.preventDefault();

                this.showModal();
            });
        }

        this.docReady(() => {
            if (
                typeof openPopupID !== "undefined" &&
                openPopupID !== 0 &&
                this.hiddenPagePopup !== null
            ) {
                this.hiddenPagePopup.click();
            }
        });

        for (let i = 0; i < popupTrigger.length; i++) {
            popupTrigger[i].addEventListener("click", (e) => {
                e.preventDefault();
                this.locker.lockScroll();

                let postId = popupTrigger[i].getAttribute("data-post-id");

                this.loadPostAjax(postId);
            });
        }

        for (let i = 0; i < this.modalClose.length; i++) {
            this.modalClose[i].addEventListener("click", (event) => {
                event.preventDefault();
                event.stopPropagation();

                this.hideModal();
            });
        }

        // for (let i = 0; i < this.modalContainer.length; i++) {
        //     this.modalContainer[i].addEventListener("click", (event) => {
        //         event.preventDefault();
        //         event.stopPropagation();
        //     });
        // }

        MicroModal.init();

        this.locker = new ScrollLocker();
    }

    docReady(fn) {
        // see if DOM is already available
        if (
            document.readyState === "complete" ||
            document.readyState === "interactive"
        ) {
            // call on next available tick
            setTimeout(fn, 1);
        } else {
            document.addEventListener("DOMContentLoaded", fn);
        }
    }

    // region all CPT ajax types
    loadPostAjax(postId, addHistory = true) {
        const apiUrl = document
            .querySelector("body")
            .getAttribute("data-api-url");
        let url = "load-article";

        let xhr = new XMLHttpRequest();
        let params = `?id=${postId}`;

        xhr.onload = () => {
            // Process our return data
            if (xhr.status >= 200 && xhr.status < 300) {
                // What do when the request is successful
                //console.log("success!", xhr);

                this.afterLoadPostAjax(xhr.response, postId, addHistory);
            } else {
                // What do when the request fails
                // console.log("The request failed!");
                //console.log('The request failed!');
            }
        };

        xhr.open("GET", apiUrl + "/" + url + params);
        //xhr.setRequestHeader("X-WP-Nonce", nonce);
        xhr.send();
    }

    afterLoadPostAjax(response, postId, addHistory) {
        let data = JSON.parse(response);

        let modalContent = document.querySelector(".js-modal-content-html");

        if (data.html) {
            modalContent.innerHTML = data.html;
        }

        if (data.post_url && addHistory) {
            history.pushState(
                {
                    url: data.post_url + location.search,
                    random: Math.random(),
                    source: "swup",
                    popup: true,
                    postId: postId,
                },
                document.title,
                data.post_url + location.search,
            );

            //history.replaceState(state, '', data.post_url + location.search);
        }

        this.showModal();
    }

    // endregion all CPT ajax types

    showModal() {
        MicroModal.show("modal", {
            onShow: (modal) => {},
            disableScroll: false,
            disableFocus: false,
            awaitOpenAnimation: true,
            awaitCloseAnimation: true,
            debugMode: true,
        });
    }

    isModalOpened() {
        return this.modal.classList.contains("is-open");
    }

    hideModal() {
        if (this.isModalOpened() === false) {
            return;
        }

        this.locker.unlockScroll();

        if (this.archiveLink !== null) {
            let url = this.archiveLink.getAttribute("data-archive-url");
            history.pushState(
                {
                    url: url,
                    random: Math.random(),
                    source: "swup",
                },
                document.title,
                url,
            );

            MicroModal.close("modal");
        }
    }
}
